// 推荐信息
import React from 'react';
import {
  Form, Input, Selector,
} from '@roo/roo';
import { get } from 'lodash';
import {
  requiredRule, phoneRule, emailRule, getRuleLen,
} from '@utils/rules';
import { positionalTitleOptions } from '@utils/positionTitle';
import Area from '../study/area';
import { FieldList } from '../../_components/FieldList';

const Field = Form.field;

const recommendInfoObj = {
  name: '',
  company: '',
  email: '',
  job: '',
  positionalTitle: '',
  studyArea: '',
  studyAreaType: '',
  researchDirection: '',
  phone: '',
  letterUrl: '',
};

export const Commend = (props) => {
  const { setFieldValue } = props;

  return (
    <FieldList
      {...props}
      name="recommendInfo"
      minCount={2}
      maxCount={5}
      iniData={recommendInfoObj}
      itemClassName="bc relative"
    >
      <Field
        required
        label="推荐人姓名"
        name="name"
        rule={{ ...requiredRule }}
        as={<Input maxLength={50} placeholder="请输入推荐人姓名" />}
      />
      <Field
        required
        label="单位名称"
        name="company"
        rule={{ ...requiredRule }}
        as={<Input maxLength={50} placeholder="请输入推荐人所在的单位" />}
      />
      <Field
        required
        label="职务"
        name="job"
        rule={{ ...requiredRule }}
        as={<Input maxLength={50} placeholder="请输入推荐人的职务" />}
      />
      <Field
        required
        label="职称"
        name="positionalTitle"
        rule={requiredRule}
        as={
          <Selector options={positionalTitleOptions} placeholder="请选择推荐人的职称" />
        }
      />
      <Field
        required
        label="手机号"
        name="phone"
        rule={{ ...requiredRule, ...phoneRule }}
        as={<Input maxLength={50} placeholder="请输入推荐人的手机号" />}
      />
      <Field
        required
        label="邮箱"
        name="email"
        rule={{ ...requiredRule, ...emailRule }}
        as={<Input maxLength={50} placeholder="请输入推荐人的联系邮箱" />}
      />

      <Field
        required
        label="学科"
        name="studyArea"
        rule={{
          validator: (rule, value1, callback) => {
            const {
              fullField,
            } = rule;
            const value = (get(props, `values.${fullField}`) || []).filter(Boolean);
            const type = get(props, `values.${fullField}`.replace('studyArea', 'studyAreaType'));
            if (type === value.length && [1, 2].includes(type)) {
              return callback();
            }
            callback('请选择推荐人所属学科领域');
          },
        }}
      >
        {(params) => {
          const {
            item, validateField, idx,
          } = params;
          return (
            <Area
              disabled={props.disabled}
              validateField={validateField}
              setFieldValue={setFieldValue}
              type={item.studyAreaType}
              typeKey={`recommendInfo.${idx}.studyAreaType`}
              studyAreaPath={item.studyAreaPath}
              studyAreaKey={`recommendInfo.${idx}.studyArea`}
              tip="请选择推荐人所属学科领域"
            />
          );
        }}
      </Field>
      <Field
        required
        label="主要研究方向"
        name="researchDirection"
        rule={getRuleLen(200, true)}
        as={<Input maxLength={200} placeholder="请输入推荐人的主要研究方向" type="textarea" />}
      />
    </FieldList>
  );
};
